import { useState } from "react";
import { PlusIcon } from "@heroicons/react/24/outline";
import { Button } from "V2.0/common/button";
import { Dialog, DialogTitle, DialogBody } from "V2.0/common/dialog";
import EmailAddressSelect from "./EmailAddressSelect";

export default function EmailAddressAdd(props) {
  const { workspaceId, onEmailAddressAdd, emailAddresses } = props;
  const [open, setOpen] = useState(false);

  return (
    <>
      <Button
        outline
        onClick={() => setOpen(true)}
      >
        <PlusIcon /> Add Email
      </Button>
      {open && (
        <Dialog
          open={open}
          onClose={() => setOpen(false)}
        >
          <DialogTitle>Add Email</DialogTitle>
          <DialogBody>
            <EmailAddressSelect
              workspaceId={workspaceId}
              onSubmit={(data) => onEmailAddressAdd(data, () => setOpen(false))}
              onCancel={() => setOpen(false)}
              emailAddresses={emailAddresses}
            />
          </DialogBody>
        </Dialog>
      )}
    </>
  );
}
